import { RoleListComponent } from '../role-list/role-list.component';
import { RoleUserAssignDialogComponent } from '../role-user-assign-dialog/role-user-assign-dialog.component';
import { Role } from '../../models/role.model';
import { UserSitesAssignDialogComponent } from '../user-sites-assign-dialog/user-sites-assign-dialog.component';
import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { UserAddDailogComponent } from '../user-add-dailog/user-add-dailog.component';
import { UserRoleAssignDialogComponent } from '../user-role-assign-dialog/user-role-assign-dialog.component';
import { UserService } from '../../services/user.service';
import { User } from '../../models/user.model';
import { MatTableDataSource } from '@angular/material/table';
import { PagedResult } from '../../models/paged-result.model';
import { PageEvent } from '@angular/material/paginator';
import { PagedInput } from '../../models/page-input.model';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Status } from '../../models/status.model';
import { SiteUser } from '../../models/usersites.model';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { LayoutService } from '../../../layout/state/layout.service';
import { LayoutQuery } from '../../../layout/state/layout.query';
import { TILES } from '../../../reference/constants/reference.constants';
import { AuthenticationService } from '../../../authentication/state/authentication.service';
import { AuthenticationQuery } from '../../../authentication/state/authentication.query';
import { AuthenticationHttpService } from '../../../authentication/services/authentication-http.service';
import { ToasterService } from '../../../core/toaster/toaster.service';
import { MatSort, Sort } from '@angular/material/sort';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { Observable, tap } from 'rxjs';


@Component({
  selector: 'app-user-management',
  templateUrl: './user-management.component.html',
  styleUrls: ['./user-management.component.scss'],
})
export class UserManagementComponent implements OnInit {
  animal: string = '';
  name: string = '';
  users: PagedResult<User> = {} as PagedResult<User>;
  selectedUser!: User;
  selectedUserRoles!: string[];
  dataSource!: MatTableDataSource<User>;
  searchForm!: FormGroup;
  searchData!: User;
  statusList!: Status[];
  @ViewChild(RoleListComponent) roleList!: RoleListComponent;
  @ViewChild(MatSort) sort!: MatSort;

  displayedColumns: string[] = [
    'firstName',
    'arabicName',
    'email',
    'departmentName',
    'statusType',
    'actions'
  ];
  userSites!: SiteUser[];
  selection: any;
  selectedTab = 0;
  selectedRole!: Role;
  usersByRole!: User[];
  selectedUserModules: any[] = [];
  isLoader: boolean = false;

  constructor(public dialog: MatDialog,
    private userService: UserService,
    private fb: FormBuilder,
    public layoutService: LayoutService,
    public layoutQuery: LayoutQuery,
    public authenticationService: AuthenticationService,
    public authenticationquery: AuthenticationQuery,
    private authHttpService: AuthenticationHttpService,
    private toasterService: ToasterService) { }

  ngOnInit() {

    this.statusList = [{ id: true, name: 'Active' }, { id: false, name: 'Inactive' }];

    this.searchForm = this.fb.group({
      userName: [null],
      email: [null],
      active: [null],
      departmentName: [null],
    });
    this.getUsers();

    this.searchData = this.searchForm.value;

    if (this.layoutQuery.layoutState.language.code === "en") {
      this.displayedColumns = [
        'firstName',
        'email',
        'departmentName',
        'statusType',
        'actions'
      ];
    } else {
      this.displayedColumns = [
        'arabicName',
        'email',
        'departmentName',
        'statusType',
        'actions'
      ];
    }

    //this.loadAssignedModulesForLoggedInUser();

  }

  private loadAssignedModulesForLoggedInUser(): void {
    this.authHttpService.getUserInfo().subscribe(
      result => {
        if (result) {
          const userId = result.sub;

          this.authHttpService.getUserTiles(userId).subscribe(
            (tiles: any[]) => {
              const roles = this.authenticationService.roles || [];

              if (roles.includes('SysAdmin')) {
                this.selectedUserModules = TILES;
              } else {
                this.selectedUserModules = tiles.map((t: any) =>
                  typeof t === 'object' ? t : this.getTileById(t)
                );
              }

              console.log('Assigned Modules for logged-in user:', this.selectedUserModules);
            },
            error => {
              console.error('Error fetching user tiles:', error);
              this.selectedUserModules = [];
            }
          );
        }
      },
      error => {
        console.error('Error fetching user info:', error);
        this.selectedUserModules = [];
      }
    );
  }


  onSearch() {
    this.searchData = this.searchForm.value;
    this.getUsers();
  }

  reset() {
    this.searchForm.reset();
    this.searchData = this.searchForm.value;
    this.getUsers();
  }

  openUserAddDialog(): void {
    const dialogRef = this.dialog.open(UserAddDailogComponent, {
      disableClose: true,
      width: '950px',
      maxWidth: '90vw',
      maxHeight: '90vh',
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result && result.success) {
        this.getUsers(undefined);
      }
    });
  }
  openUserRoleAssignDialog(): void {
    let data = {};
    if (this.selectedUser) {
      data = { userId: this.selectedUser.id, selectedUserRoles: this.selectedUserRoles }
    }
    const dialogRef = this.dialog.open(UserRoleAssignDialogComponent, {
      disableClose: true,
      width: '450px',
      data
    });

    dialogRef.afterClosed().subscribe(result => {
      if (this.selectedUser) {
        this.getRoles(this.selectedUser.id);
      }
    });
  }

  public getUsers(pageIndex?: PagedInput) {
    this.isLoader = true; // 🔹 Start loader

    this.userService
      .getUsers(this.searchData, pageIndex)
      .subscribe({
        next: (users) => {
          this.users = users;
          this.searchForm.setValue(this.searchData);

          if (users.results?.length > 0) {
            this.selectedUser = users.results[0];
            this.getRoles(users.results[0].id).subscribe({
              next: () => {
                this.onRowClick(users.results[0]);
              },
              error: (err: any) => {
                console.error('Error fetching roles:', err);
              }
            });
          }

          this.dataSource = new MatTableDataSource(users.results);
          this.dataSource.sort = this.sort;
        },
        error: (err) => {
          console.error('Error fetching users:', err);
          this.isLoader = false; // 🔹 Stop loader on error
        },
        complete: () => {
          this.isLoader = false; // 🔹 Stop loader when request completes
        }
      });
  }


  sortData(sort: Sort) {
    if (!sort.active || sort.direction === '') {
      return;
    }

    const data = this.users.results.slice();
    this.dataSource.data = data.sort((a, b) => {
      const isAsc = sort.direction === 'asc';
      switch (sort.active) {
        case 'firstName':
          return this.compare(a.firstName, b.firstName, isAsc);
        case 'arabicName':
          return this.compare(a.arabicName, b.arabicName, isAsc);
        case 'email':
          return this.compare(a.email, b.email, isAsc);
        case 'departmentName':
          return this.compare(a.departmentName, b.departmentName, isAsc);
        case 'statusType':
          return this.compare(a.statusType, b.statusType, isAsc);
        default:
          return 0;
      }
    });
  }

  private compare(a: string | number, b: string | number, isAsc: boolean) {
    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

  onUserEdit(user: User) {
    this.onRowClick(user);

    const dialogRef = this.dialog.open(UserAddDailogComponent, {
      disableClose: true,
      width: '900px',
      maxWidth: '90vw',
      maxHeight: '90vh',
      data: user
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result && result.success) {
        this.toasterService.success("User details updated successfully");
        this.getUsers(undefined);
      }
    });
  }

  onRowClick(user: User) {
    this.selectedUser = user;

    this.getRoles(user.id);

    if (this.selectedUserRoles && this.selectedUserRoles.includes('SysAdmin')) {
      this.selectedUserModules = TILES;
    } else {
      if (user.tiles && user.tiles.length > 0) {
        this.selectedUserModules = user.tiles.map((t: any) => {
          const tileId = t.tileId ?? t.id;
          return this.getTileById(tileId);
        });
      } else {
        this.selectedUserModules = [];
      }
    }
  }

  getTileById(id: number) {
    const allTiles = TILES || [];
    return allTiles.find((tile: any) => tile.id === id) || { id, title: `Unknown (${id})` };
  }

  // getUserSites(userId: string) {
  //   this.userService.getSiteByUserId(userId).subscribe((response: SiteUser[]) => {
  //     this.userSites = response.filter(x => x.canView === true);
  //   });
  // }
  getRoles(userId: string): Observable<any> {
    return this.userService.getRoles(userId).pipe(
      tap((response) => {
        this.selectedUserRoles = response;
      })
    );
  }

  openUserSitesAssignDialog() {
    let data = {};
    if (this.selectedUser) {
      data = { userId: this.selectedUser.id }
    }

    const dialogRef = this.dialog.open(UserSitesAssignDialogComponent, {
      disableClose: true,
      width: '450px',
      data
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.onRowClick(this.selectedUser);
      }
    });
  }

  get totalLength() {
    return this.users.rowCount;
  }

  get pageSize() {
    return this.users.pageSize;
  }

  get hasRows() {
    return this.users.rowCount !== 0;
  }
  get pageIndex() {
    return this.users.currentPage - 1;
  }

  page(event: PageEvent) {
    this.getUsers({
      currentPage: event.pageIndex + 1,
      pageSize: event.pageSize
    } as PagedInput);
  }

  tabChanged(tabChangeEvent: MatTabChangeEvent): void {
    this.selectedTab = tabChangeEvent.index;
  }

  selectedRoleParent(role: Role) {
    this.selectedRole = role;
    if (role) {
      this.getUsersByRole(role.name);
    }
  }

  getUsersByRole(roleName: string) {
    this.userService.getUsersByRole(roleName).subscribe(response => {
      this.usersByRole = response;
    });
  }

  openRoleUserAssignDialog(): void {
    let data = {};
    if (this.selectedUser) {
      data = { users: this.usersByRole, role: this.selectedRole }
    }
    const dialogRef = this.dialog.open(RoleUserAssignDialogComponent, {
      disableClose: true,
      width: '450px',
      data
    });

    dialogRef.afterClosed().subscribe(result => {
      this.roleList.getRoles();
    });
  }


  exportToExcel(): void {
    const allDataRequest = {
      currentPage: 1,
      pageSize: 100000
    };

    this.userService.getUsers(this.searchData, allDataRequest).subscribe({
      next: (users) => {
        if (!users.results || users.results.length === 0) {
          this.toasterService.warning('No data available to export.');
          return;
        }

        const exportData = users.results.map((user: User) => {
          let modules: string[] = [];

          if (this.selectedUserRoles.includes('SysAdmin')) {
            modules = TILES.map((t: any) => t.title);
          }
          else if (user.tiles && user.tiles.length > 0) {
            modules = user.tiles.map((t: any) => {
              const tileId = t.tileId ?? t.id;
              const tile = this.getTileById(tileId);
              return tile?.title || `Unknown (${tileId})`;
            });
          }

          return {
            Name: this.layoutQuery.layoutState.language.code === 'en' ? user.firstName : user.arabicName,
            Email: user.email,
            Department: user.departmentName,
            Status: user.statusType ? 'Active' : 'Inactive',
            Modules: modules.join(', ')
          };
        });

        const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(exportData);
        const workbook: XLSX.WorkBook = {
          Sheets: { Users: worksheet },
          SheetNames: ['Users']
        };

        const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
        const blob: Blob = new Blob([excelBuffer], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        });

        const fileName = `UserList_${new Date().toISOString().slice(0, 10)}.xlsx`;
        saveAs(blob, fileName);

        this.toasterService.success('Excel exported successfully.');
      },
      error: (err) => {
        console.error('Error exporting users:', err);
        this.toasterService.error('Failed to export Excel file.');
      }
    });
  }
}
